<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-lock-reset
      </v-icon> Passcode Reset
    </h2>
    <br>
    <v-card color="#CFD8DC">
      <br>
      <p
        v-if="verificationSuccess"
        class="success-message-style"
      >
        <font>
          <v-icon
            size="30"
            color="#2E7D32"
          >
            mdi-check-all
          </v-icon> <br>
          {{ verificationSuccessMessage }}
        </font>
      </p>
      <p
        v-if="verificationFailed"
        class="fail-message-style"
      >
        <font>
          <v-icon
            size="30"
            color="#C62828"
          >
            mdi-close-thick
          </v-icon> <br>
          {{ verificationFailedMessage }}
        </font>
      </p>
      <v-card
        class="card-style"
        color="#ECEFF1"
        :style="getBgStyle"
      >
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-card-text class="justify-center">
            <v-container fluid>
              <p class="passcode-reset-title">
                Please provide the mobile number you used to register for your account.
              </p>
              <br>
              <v-text-field
                v-model="mobileNumber"
                label="Enter Mobile Number*"
                outlined
                :rules="[(v) => !!v || 'This field is required']"
                color="#000000"
                type="number"
                inputmode="numeric"
                dense
                filled
                light
              />
              <v-card-actions>
                <v-spacer />
                <v-btn
                  class="mt-2"
                  color="#37474F"
                  @click="cancel()"
                >
                  Cancel
                </v-btn>
                <v-btn
                  class="mt-2"
                  color="#FF3700"
                  :light="verificationSuccess"
                  :disabled="verificationSuccess"
                  @click="confirmMobile()"
                >
                  Confirm
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-container>
          </v-card-text>
        </v-form>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
      <br>
      <br>
    </v-card>
  </v-container>
</template>
<script>
import Constants from 'src/constants';
import spinner from 'src/views/components/SpinnerCentre';

export default {
  name: 'ConfirmMobileNumber',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      loading: false,
      mobileNumber: null,
      valid: false,
      cardBgImg: require('@/assets/img/cardBg.png'),
      verificationFailed: false,
      verificationFailedMessage: '',
      verificationSuccess: false,
      verificationSuccessMessage: '',
    };
  },
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
  },
  mounted () {
    this.loadOnMount();
  },
  methods: {
    loadOnMount () {
      const previousSignedInNumber = localStorage.getItem('previousSignedInAccount');
      if (previousSignedInNumber !== null) {
        this.mobileNumber = previousSignedInNumber;
        return;
      }
      this.mobileNumber = null;
    },
    confirmMobile () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      const siteId = this.$route.params.siteId;
      this.$store.dispatch('passcodereset/confirmMobile', {
        phone_number: this.mobileNumber,
        site_id: siteId,
      }).then(() => {
        this.loading = false;
        this.verificationSuccess = true;
        this.verificationSuccessMessage = 'You will shortly receive a text message with instructions on how to reset your passcode.';
      }).catch(error => {
        this.loading = false;
        this.verificationFailed = true;
        this.verificationFailedMessage = error.response.data.message;
      });
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 10px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 25px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.fail-message-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:'Times New Roman', Times, serif;
  text-align: center;
}
.success-message-style {
  font-size: 18px;
  font-weight: bold;
  color: #2E7D32;
  font-family:'Times New Roman', Times, serif;
  text-align: center;
}
.passcode-reset-title {
  font-size: 18px;
  font-weight: bold;
  color: #37474F;
  text-align: center;
  margin-bottom: 15px;
  font-family:'Times New Roman', Times, serif;
}
</style>
